// NFR link-scheme (developer-portal-log-output-xss precedent) — `RepositoryUrl` is a
// publisher-controlled string. `true` only for `http:`/`https:`; every other scheme
// (`javascript:`, `data:`, `file:`, blank/whitespace-only, garbage) is `false`, so callers
// render inert text instead of an anchor. Uses the WHATWG `URL` constructor (which
// normalises the scheme to lowercase and strips ASCII tab/newline from the whole input per
// spec) rather than a regex, so scheme tricks — leading whitespace, mixed case, a
// tab/newline hidden inside the scheme (`java\tscript:`) — can't slip past a naive prefix
// check. Never throws on any input.
const SAFE_PROTOCOLS = new Set(['http:', 'https:']);

export const isSafeExternalUrl = url => {
	if (typeof url !== 'string') {
		return false;
	}

	const trimmed = url.trim();
	if (!trimmed) {
		return false;
	}

	try {
		const parsed = new URL(trimmed);
		return SAFE_PROTOCOLS.has(parsed.protocol.toLowerCase());
	} catch {
		return false;
	}
};

export default isSafeExternalUrl;
